import { render, staticRenderFns } from "./doctorGradeList.vue?vue&type=template&id=1c1afb38"
import script from "./doctorGradeList.vue?vue&type=script&lang=js"
export * from "./doctorGradeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports